export default "__VITE_ASSET__8fafb0f0__"